/**
 * Angular 2 decorators and services
 */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

@Component({
  selector: 'modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

/**
 *
 * Modal Header component.
 * @class ModalHeaderComponent
 *
 */
export class ModalHeaderComponent {
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;

  @Input() public title: string;
  @Input() public isHeaderShown = false;
}
